import { defineStore } from 'pinia'
import axios from 'axios'

export const useAppStore = defineStore('app', {
  state: () => ({ 
    app: {},
    allApps: {},
    appState: {},
    builds: [],
    loading: false,
    query: '',
  }),
  actions: {
    async loadAllApps () {
      const req = await axios.get('/api/apps')      
      const data = req.data?.items || []
      const apps = {}
      data.map(item => {
        apps[item.id] = item
      })
      this.allApps = apps
    },
    async loadAppState (universe, app) {
      const req = await axios.get(`/api/universe/${universe}/apps/${app}`)
      const { data, ...appState } = req.data
      return appState
    },
    async loadBuildLogs (universe, app) {
      const req = await axios.get(`/api/universe/${universe}/apps/${app}/builds/running-logs`)
      return req.data
    },
    async loadBuildHistory (universe, app, buildId) {
      const req = await axios.get(`/api/universe/${universe}/apps/${app}/build/${buildId}`)
      return req.data
    },
    async loadApps (universe) {
        const req = await axios.get(`/api/universe/${universe}/apps/`)
        return req.data
    },    
    async loadApp (universe, app) {
      const req = await axios.get(`/api/universe/${universe}/apps/${app}`)
      const { data, ...appState } = req.data
      this.app = data
      this.appState = appState
      return data
    },   
    async deleteApp (data) {
      this.loading = true        
      const universe = data.universe
      await axios.delete(`/api/universe/${universe}/apps/${data.name}`)
      this.loading = false
    },
    async startApp (universe, app) {
      this.loading = true        
      await axios.get(`/api/universe/${universe}/apps/${app}/start`)
      this.loading = false
    },
    async stopApp (universe, app) {
      this.loading = true        
      await axios.get(`/api/universe/${universe}/apps/${app}/stop`)
      this.loading = false
    },
    async buildApp (universe, app) {
      this.loading = true        
      await axios.get(`/api/universe/${universe}/apps/${app}/build`)
      this.loading = false
    },
    async cancelBuild (universe, app) {
      this.loading = true        
      await axios.get(`/api/universe/${universe}/apps/${app}/cancel`)
      this.loading = false
    },
    async saveApp (data) {
        this.loading = true        
        const universe = data.universe
        await axios.put(`/api/universe/${universe}/apps/`, {
          id: universe + '-' + data.name,
          name: data.name,
          universe: universe,
          public: data.public,
          visitor: data.visitor,
          data: data,
        })
        this.loading = false
    },
    async createApp (data) {
      this.loading = true        
      const universe = data.universe
      await axios.post(`/api/universe/${universe}/apps/`, {
        id: universe + '-' + data.name,
        name: data.name,
        universe: universe,
        public: data.public,
        visitor: data.visitor,
        data: data,
      })
      this.loading = false
    },
    async loadBuilds (universe, app) {
      this.loading = true
      const req = await axios.get(`/api/universe/${universe}/apps/${app}/builds`)      
      this.builds = req.data
      this.loading = false
    },
    async loadVersion (universe, app) {
      this.loading = true
      const req = await axios.get(`/api/universe/${universe}/apps/${app}/version`)
      this.loading = false
      return req.data || 'latest'
    },
    async setVersion (universe, app, version) {
      this.loading = true
      await axios.post(`/api/universe/${universe}/apps/${app}/version/${version}`)
      this.loading = false
    },
    async loadAppLogs (universe, app) {
      const req = await axios.get(`/api/universe/${universe}/apps/${app}/logs`)
      return req.data
    },
    async loadMetrics (universe, app) {
      const req = await axios.get(`/api/universe/${universe}/apps/${app}/metrics`)
      return req.data
    },
  },
})
